<template>
    <div>
        <div class="payInfo orderInfo">
            <van-row type="flex" justify="center" class="row_icon">
                <van-col span="22" align="center"><van-icon name="checked" color="#FD6A55" class="payResultIcon"/></van-col>
            </van-row>        
            <van-row type="flex" justify="center" align="center">
                <van-col span="22" align="center" class="payResultText">购买成功</van-col>
            </van-row>
            <van-row type="flex" justify="center" align="center">
                <van-col span="22" align="center" class="payResultTips">
                    <p>恭喜您已成功预约，芒果TV全屏会员月卡</p>
                    <p>已充值到账户（<span class="userAccount">{{userInfo.nickname}}</span>）</p>
                </van-col>
            </van-row>
            <van-row type="flex" justify="center" align="center">
                <van-col span="22" align="center" class="payResultTips1">敬请继续关注商品现货首发活动时间<br>2018.08.04至2018.08.12</van-col>
            </van-row>        
        </div>

        <div class="payInfo goInfo">
            <van-row type="flex" justify="center" class="row_icon">
                <van-col span="22" align="center"><van-icon name="checked" color="#FD6A55" class="payResultIcon"/></van-col>
            </van-row>        
            <van-row type="flex" justify="center" align="center">
                <van-col span="22" align="center" class="payResultText">购买成功</van-col>
            </van-row>
            <van-row type="flex" justify="center" align="center">
                <van-col span="22" align="center" class="payResultTips">
                    <p>您已成功购买，芒果TV全屏会员年卡</p>
                    <p>已充值到账户（<span class="userAccount">{{userInfo.nickname}}</span>）</p>
                </van-col>
            </van-row>
            <van-row type="flex" justify="center" align="center">
                <van-col span="22" align="center" class="payResultTips2"><span>牛奶盒子在活动结束后一周内发货<br>请留意配送短信</span></van-col>
            </van-row> 
            <div class="footer">
                <div class="footerContent">
                    <van-button type="default" @click="viewMyOrder" class="viewMyOrder">查看我的订单</van-button>
                    <p class="viewMyOrderTips">如有疑问，请与客服联系。客服电4009770707</p>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import click_handler from "../tools/mgtv/click";
    import { page_view, click_event } from "../tools/mgtv/analysis";
    import { Row, Col,Icon,Button } from 'vant';
    import {mapState, mapActions} from 'vuex'
    Vue.use(Row).use(Col).use(Icon).use(Button);
    export default {
        name:"pay-success"
        ,
        computed: {
            ...mapState([
                'actInfo',
                'userInfo',
                'deviceInfo',
                'urlParams',
                'ticket',
                'product'
            ])
        },
        mounted(){
            page_view("支付成功页",this)
        },
        methods:{
            viewMyOrder() {
                click_handler(
                    "支付成功页-查看我的订单",
                    () => {
                        this.$router.push({
                            path: `/OrderList`,
                            query: this.$route.query
                        });
                    },
                    {
                        need_login: true,
                        need_act: true,
                        login:this.requestLogin
                    },
                this);
            }
        }
    }
</script>
<style lang="stylus">
    @import "../share/mixins.styl"
    .payInfo
        display none
        padding-top 1rem
        .van-row 
            padding 0
        .row_icon
            height 0.9rem
            .payResultIcon
                font-size 0.9rem
        .payResultText
            font-size 0.48rem
            line-height 0.76rem
            color #FD6A55
            margin-top 0.46rem
        .payResultTips
            font-size 0.3rem        
            line-height 0.5rem
            .userAccount
                color #FD6A55
                
        .payResultTips2,.payResultTips1
            margin-top 0.6rem            
            line-height 0.5rem
            font-size 0.3rem
        .payResultTips1
            opacity 0.4

    .goApp
        .goInfo
            display block
        .orderInfo
            display none 
    .orderApp
        .goInfo
            display none
        .orderInfo
            display block   
    .footer
        width 100%
        position fixed
        left 0
        bottom 3rem
        .footerContent
            width 100%
            .viewMyOrder
                display block
                margin 0 auto
                width 6.8rem
                height 0.9rem
                line-height 0.9rem
                background-image linear-gradient(-180deg, #FFEBA4 3%, #E0B580 100%)
                border-radius 1rem
                font-size 0.32rem
                color #0B0E1A
            .viewMyOrderTips
                padding-top 0.33rem
                text-align center
                font-size 0.24rem
</style>




// WEBPACK FOOTER //
// src/pages/PaySuccess.vue